
<div [innerHTML]="htmlCode"></div>

